import { Box } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import { StaticImage } from 'gatsby-plugin-image'
import Suisse from '../../../frontend-lib/typhograpy/Suisse'

export function TakeItFromHappyMembersCard({
  quote,
  name,
  title,
  subtitle,
  organization,
  logo,
}) {
  return (
    <Box
      sx={{
        backgroundColor: 'grey.5',
        borderRadius: '16px',
        p: 5,
        display: 'flex',
        flexDirection: 'column',
        width: '292px',
        mx: { xs: 4, md: 0 },
      }}
    >
      <Box>
        <StaticImage
          src="../../../../static/images/quotes.png"
          alt="Quotes icon"
          height={24}
        />
      </Box>
      <Box sx={{ mt: 4 }}>
        <Suisse size={16} color="grey.1">
          {quote}
        </Suisse>
      </Box>
      <Box sx={{ mt: 4 }}>
        <Suisse size={14} color="grey.1">
          {name}
        </Suisse>
        <Suisse size={14} color="grey.1">
          {title}
        </Suisse>
        <Suisse size={14} color="grey.1">
          {subtitle}
        </Suisse>
        <Suisse size={14} color="grey.1">
          {organization}
        </Suisse>
        <Box sx={{ mt: 2 }}>{logo}</Box>
      </Box>
    </Box>
  )
}

TakeItFromHappyMembersCard.propTypes = {
  quote: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  organization: PropTypes.string,
  logo: PropTypes.element,
}

TakeItFromHappyMembersCard.defaultProps = {
  subtitle: null,
  organization: null,
  logo: null,
}
